/** @format */
import { css } from 'styled-components';

import { RequestPasswordResetFormStyleProps } from './index';

/**
 * Base styles for the request password reset form component
 */
const baseStyles = css`
    text-align: left;

    .heading,
    .submit {
        text-align: center;
    }

    .info-text {
        margin-bottom: var(--layout-spacing-12);
    }
`;

/**
 * The request password reset form component styles
 *
 * @param {RequestPasswordResetFormStyleProps} props The request password reset form properties object
 * */
export const styles = (props: RequestPasswordResetFormStyleProps) => css`
    ${baseStyles}
`;
